import {
  useQuery,
  keepPreviousData,
  useQueryClient,
} from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";

export default function useCandidateNotes(candidateId, page = 1) {
  const api = useAxios();
  const client = useQueryClient();

  const { data, error, isPending, isPlaceholderData } = useQuery({
    queryKey: ["candidateNotes", candidateId, page],
    queryFn: () => {
      return api.get(`/candidate/${candidateId}/notes`, {
        params: { page },
      });
    },
    placeholderData: keepPreviousData,
    enabled: !!candidateId,
  });

  handleError(error);

  const notes = data?.data?.data ?? [];
  const lastPage = data?.data?.meta?.last_page ?? 1;

  const invalidate = () => {
    client.invalidateQueries({ queryKey: ["candidateNotes", candidateId] });
  };

  return {
    notes,
    lastPage,
    isLoading: isPending,
    isPlaceholderData,
    invalidate,
  };
}
